module.exports = __webpack_public_path__ + "static/media/shn.d7c2c62d.svg";